import { globalLayoutRoute } from "@routes";
import { requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const horizonRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `horizon`,
    component: lazyRouteComponent(() => import("./index")),
    beforeLoad: () => requireScope("account"),
});
